export const farmaciMock = [
  {
    id: "farm_001",
    nome: "Tachipirina",
    formaFarmaceutica: "Compresse",
    dosaggio: "1000 mg",
  },
  {
    id: "farm_002",
    nome: "Tachipirina",
    formaFarmaceutica: "Supposte",
    dosaggio: "500 mg",
  },
  {
    id: "farm_003",
    nome: "Aspirina C",
    formaFarmaceutica: "Bustine",
    dosaggio: "400 mg",
  },
  {
    id: "farm_004",
    nome: "Brufen",
    formaFarmaceutica: "Compresse",
    dosaggio: "600 mg",
  },
  {
    id: "farm_005",
    nome: "Moment",
    formaFarmaceutica: "Capsule molli",
    dosaggio: "200 mg",
  },
  {
    id: "farm_006",
    nome: "Augmentin",
    formaFarmaceutica: "Sospensione orale",
    dosaggio: "875 mg/125 mg",
  },
  {
    id: "farm_007",
    nome: "Bentelan",
    formaFarmaceutica: "Compresse effervescenti",
    dosaggio: "1 mg",
  },
  {
    id: "farm_008",
    nome: "Gaviscon",
    formaFarmaceutica: "Sciroppo",
    dosaggio: "500 mg/10 ml",
  },
];

export const formeFarmaceuticheMock = [
  ...new Set(farmaciMock.map((farmaco) => farmaco.formaFarmaceutica)),
];

export const dosaggiMock = [
  ...new Set(farmaciMock.map((farmaco) => farmaco.dosaggio)),
];

